// Popups do colib (Base UI) que tratam o Esc sozinhos: menu, submenu, popover e Select.
const OPEN_COLIB_POPUP = [
  '[data-slot="dropdown-menu-content"][data-open]',
  '[data-slot="dropdown-menu-sub-content"][data-open]',
  '[data-slot="popover-content"][data-open]',
  '[data-slot="select-content"][data-open]',
].join(', ');

// Conteúdo de Dialog/Drawer/Sheet do ui (Radix). Os popups do colib também têm role dialog, mas trazem data-slot.
export const LEGACY_OVERLAY = '[role="dialog"]:not([data-slot])';

/**
 * Passe em `onEscapeKeyDown` do Dialog/Drawer/Sheet do ui que hospeda menus, popovers ou Selects do colib.
 *
 * O DismissableLayer do Radix escuta o Esc no document em captura, antes do Base UI; sem isto o Esc de um popup do
 * colib fecha também o overlay. Só conta popup aberto dentro do mesmo overlay do foco: um popup em outra parte da
 * página não segura o Esc deste overlay. O Base UI ainda fecha o popup.
 */
export const keepOverlayOpenOnColibEscape = (event: KeyboardEvent) => {
  const target = event.target instanceof Element ? event.target : null;
  const overlay = target?.closest(LEGACY_OVERLAY);
  const popups = Array.from(document.querySelectorAll(OPEN_COLIB_POPUP));
  if (popups.some((popup) => !overlay || overlay.contains(popup))) event.preventDefault();
};
